// extracted by mini-css-extract-plugin
export default {"container":"UpdatesView_container__lMyeq","headerCard":"UpdatesView_headerCard__a87Pi"};